import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const ProvinceIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [provincePageIndex, setProvincePageIndex] = useState(1);
    const [provincePageSize, setProvincePageSize] = useState(store.main.pageSize);
    const [provinceIdList, setProvinceIdList] = useState([]);
    const [provinceTotal, setProvinceTotal] = useState(0);
    const [provinceList, setProvinceList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/province/index"});

            handleSearchProvince();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadProvince(provincePageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadProvince(provincePageIndex, provincePageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchProvince = () => {
        handleLoadProvince(1, provincePageSize);
    };

    const handleLoadProvince = (provincePageIndex, provincePageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = provincePageIndex;
        data.pageSize = provincePageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/province/business/website/v1/list",
            data: data,
            success: (response) => {
                setProvincePageIndex(provincePageIndex);
                setProvincePageSize(provincePageSize);
                setProvinceIdList([]);
                setProvinceTotal(response.data.total);
                setProvinceList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddProvince = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/province/add",
        });
    };

    const handleEditProvince = (provinceId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/province/edit/" + provinceId,
        });
    };

    const handleDelProvince = () => {
        if (provinceIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/province/business/website/v1/delete",
                    data: {
                        provinceIdList: provinceIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setProvinceIdList([]);

                        handleLoadProvince(provincePageIndex, provincePageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeProvinceIdList = (provinceIdList) => {
        setProvinceIdList(provinceIdList);
    };

    const handleChangeProvincePagination = (provincePageIndex, provincePageSize) => {
        handleLoadProvince(provincePageIndex, provincePageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddProvince}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={provinceIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelProvince}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchProvince}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="省份名称"
                                labelAlign={"left"}
                                name="provinceName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入省份名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入省份名称" onPressEnter={handleSearchProvince} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.provinceId}
                        columns={[
                            {
                                title: "省份名称",
                                dataIndex: "provinceName",
                            },
                            {
                                title: "省份排序",
                                dataIndex: "provinceSort",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditProvince(record.provinceId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={provinceList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: provinceIdList,
                            onChange: handleChangeProvinceIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: provincePageIndex,
                            pageSize: provincePageSize,
                            total: provinceTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeProvincePagination,
                            onShowSizeChange: handleChangeProvincePagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

ProvinceIndex.propTypes = {};

ProvinceIndex.defaultProps = {};

export default ProvinceIndex;
